export enum MapEnum {
  GOOGLE = 'GoogleMaps',
  MAPBOX = 'MapBox',
  OSM = 'OSM'
}
